import styled, { css } from 'styled-components/macro';
import { colorCoreBlack300, colorCoreBlack900Base, colorCoreWhite1000, colorWhiteTransparent000000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
const LAST_STEP_NUMBER = 4;
const leftShadow = css `
  &::before {
    left: 0;
    background-image: linear-gradient(
      to right,
      ${colorCoreWhite1000} 25%,
      ${colorWhiteTransparent000000} 100%
    );
    opacity: 1;
  }
`;
const rightShadow = css `
  &::after {
    right: 0;
    background-image: linear-gradient(
      to left,
      ${colorCoreWhite1000} 25%,
      ${colorWhiteTransparent000000} 100%
    );
    opacity: 1;
  }
`;
const getShadow = (isLeftVisible = true, isRightVisible = true, isRightToLeft) => {
    const firstShadow = isRightToLeft ? rightShadow : leftShadow;
    const lastShadow = isRightToLeft ? leftShadow : rightShadow;
    const bothShadow = isRightToLeft
        ? css `
        ${rightShadow} ${leftShadow}
      `
        : css `
        ${leftShadow} ${rightShadow}
      `;
    if (!isLeftVisible && !isRightVisible) {
        return bothShadow;
    }
    if (!isLeftVisible) {
        return firstShadow;
    }
    if (!isRightVisible) {
        return lastShadow;
    }
    return '';
};
export const StepIconStyled = styled(FlexWrapper) `
  box-sizing: border-box;
  min-width: 36px;
  width: 36px;
  height: 36px;
  border-style: solid;
  border-width: 1px;

  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: 16px;' : 'margin-right: 16px;')}
  border-radius: ${CORNER_RADIUS.circle};
  border-color: ${({ borderColor }) => borderColor};
  background: ${({ isCurrentStep, borderColor }) => (isCurrentStep ? borderColor : 'transparent')};
  color: ${({ isCurrentStep }) => (isCurrentStep ? colorCoreWhite1000 : colorCoreBlack900Base)};
`;
export const StepStyled = styled.li `
  &:not(:last-child) {
    ${({ isRightToLeft }) => !isRightToLeft && 'margin-right: 12px;'}
  }

  &:not(:first-child) {
    ${({ isRightToLeft }) => isRightToLeft && 'margin-right: 12px;'}
  }
`;
export const StepsListStyled = styled.ol `
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  padding: 20px 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    display: block;
    height: 100%;
    width: 40px;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
  }

  ${({ isFirstOnScreen, isLastOnScreen, isRightToLeft }) => getShadow(isFirstOnScreen, isLastOnScreen, isRightToLeft)};
`;
export const StepTextStyled = styled(RegularTextLevel3) `
  color: ${({ isNextStep }) => isNextStep && `${colorCoreBlack300}`};

  display: flex;
  align-items: center;

  ::after {
    display: inline-block;
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-position: 50%;

    ${({ number }) => number !== LAST_STEP_NUMBER && "content:'';"} // TODO(A.N.): check another approach 
    ${({ isRightToLeft }) => (isRightToLeft ? ' margin-right: 12px;' : ' margin-left: 12px;')}
    ${({ isRightToLeft }) => (isRightToLeft ? 'left: 0;' : 'right: 0;')}
    ${({ isRightToLeft }) => isRightToLeft && 'transform: rotate(180deg);'}
    ${({ iconUrl }) => iconUrl && `background-image: url(${iconUrl})`};
  }
`;
export const NavStyled = styled.nav `
  overflow-y: hidden;
  overflow-x: scroll;
  user-select: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
export const StepsStyled = styled.div `
  width: 100%;

  ${({ isRightToLeft }) => isRightToLeft && 'direction: rtl;'}
`;
export const StepWrapperStyled = styled.div `
  display: flex;
  align-items: center;
  white-space: nowrap;
`;
export const StepsWrapperStyled = styled.div `
  background-color: ${colorCoreWhite1000};
`;
